import {
    useCallback,
    useRef
} from "react";

const useStableCallback = <A extends Array<unknown>, R>(callback: (...args: A) => R): ((...args: A) => R) => {
    const callbackRef = useRef(callback);

    callbackRef.current = callback;

    return useCallback((...args: A) => callbackRef.current(...args), []);
};
export default useStableCallback;
